<template>
  <div class="pb-2 position-relative">
    <input
      type="text"
      placeholder="Search"
      class="form-control search pr-4"
      v-model="mySearchTerm"
      @input="updateSearch" />
    <span class="clear-container" v-if="mySearchTerm" @click="clearSearch">
      <i class="fas fa-times-circle text-danger" title="Clear search"></i>
    </span>
  </div>
</template>

<script>
export default {
  props: ['search_term'],
  data() {
    return {
      mySearchTerm: this.search_term,
    };
  },

  watch: {
    search_term: function (newTerm) {
      this.mySearchTerm = newTerm;
    }
  },

  methods: {
    updateSearch() {
        this.$emit('update-search', this.mySearchTerm);
    },

    clearSearch() {
        this.mySearchTerm = '';
        this.$emit('update-search', this.mySearchTerm);
    },
  }

}

</script>

<style scoped>
.clear-text {
  text-transform: none !important;
  font-size: 0.8rem;
  position:relative;
  top:-2px;
}
.clear-container {
  top: 4px;
  right: 15px;
  cursor: pointer;
  font-size: 1rem;
  position: absolute;
}
</style>